
$(document).ready(function(){
  $('#select-your-location').change(function(){
    var selectedOption = $(this).find('option:selected');
    var location = selectedOption.attr('location');
    
    $('.select_time_one, .select_time_two, .select_time_three, .select_time_four, .select_time_five, .select_time_six, .select_time_seven, .select_time_eight, .select_time_nine, .select_time_ten').removeAttr('name');
    $('.delivery_date_one input, .delivery_date_two input, .delivery_date_three input, .delivery_date_four input, .delivery_date_five input, .delivery_date_six input, .delivery_date_seven input, .delivery_date_eight input, .delivery_date_nine input, .delivery_date_ten input').removeAttr('name');

    if (location === '#itg_location_one') {
      $('.select_time_one').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_one input').attr('name', 'properties[Delivery Date]');
    } else if (location === '#itg_location_two') {
      $('.select_time_two').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_two input').attr('name', 'properties[Delivery Date]');
    } else if (location === '#itg_location_three') {
      $('.select_time_three').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_three input').attr('name', 'properties[Delivery Date]');
    } else if (location === '#itg_location_four') {
      $('.select_time_four').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_four input').attr('name', 'properties[Delivery Date]');
    } else if (location === '#itg_location_five') {
      $('.select_time_five').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_five input').attr('name', 'properties[Delivery Date]');
    } else if (location === '#itg_location_six') {
      $('.select_time_six').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_six input').attr('name', 'properties[Delivery Date]');
    } else if (location === '#itg_location_seven') {
      $('.select_time_seven').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_seven input').attr('name', 'properties[Delivery Date]');
    }else if (location === '#itg_location_eight') {
      $('.select_time_eight').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_eight input').attr('name', 'properties[Delivery Date]');
    }else if (location === '#itg_location_nine') {
      $('.select_time_nine').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_nine input').attr('name', 'properties[Delivery Date]');
    }
    else if (location === '#itg_location_ten') {
      $('.select_time_ten').attr('name', 'properties[Delivery Time]');
      $('.delivery_date_ten input').attr('name', 'properties[Delivery Date]');
    }
  });
});





function checkLength(){
    var selectLength = $('#select-your-location option:selected').text();
    var deliveryDate = $('.active_select .delivery_date input').val();
    var selectTime = $('.active_select #select-your-time option:selected').text();

    if(selectLength != 'Select Location' && deliveryDate != '' && selectTime != 'Select Your Time'){
        $('.overlay_btn').removeClass('active');
        $('p.warning_message').removeClass('active');
    } else {
        $('p.warning_message').addClass('active');
        $('.overlay_btn').addClass('active');
    }
}

$(document).ready(function(){
    $(document).on('change input', '#select-your-location, .delivery_date input, #select-your-time', function(){
        checkLength();
    });
});

$(document).on('click', 'span.overlay_btn', function(){
    checkLength();
});